// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import VueJsonp from 'vue-jsonp'
import './icons'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css'
import store from './store'
import './assets/css/style.css'
// import './assets/css/app.css'//不引入样式
// import './assets/css/common.css'
import './assets/css/iconfont.css'
import './assets/css/reset.css'
import './assets/css/less.css'


Vue.use(ElementUI);
Vue.use(VueJsonp);
Vue.use(Share);
Vue.config.productionTip = false
// Vue.prototype.$jsonp = VueJsonp

Storage.prototype.setExpire=(key, value, expire,time=Date.now()) =>{
  let obj={
    data:value,
    time: time,
    expire:expire
  };
  localStorage.setItem(key,JSON.stringify(obj));
}
Storage.prototype.getExpire= key =>{
    let val =localStorage.getItem(key);
    if(!val){
        return val;
    }
    val =JSON.parse(val);
    if(Date.now()-val.time>val.expire){
        localStorage.removeItem(key);
        return null;
    }
    return val.data;
}



// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面meta */
//   console.log(to.meta.content)
//   if(to.meta.content){
//     let head = document.getElementsByTagName('head');
//     let meta = document.createElement('meta');
//     document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
//     document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
//     meta.content = to.meta.content;
//     console.log(meta[name="keywords"])
//     head[0].appendChild(meta)
//   }
//   // /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next()
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js